import NoData from "../../../../../components/noData/noData";
import { useNavigate } from "react-router-dom";

// Reusable DetailCard component
const DetailCard = ({ label, value }) => (
  <div className="grid grid-cols-2">
    <span className="text-sm text-gray-500">{label}</span>
    <span className="text-sm font-semibold text-blue-900">
      {Array.isArray(value) ? (
        <div className="flex flex-wrap gap-2">
          {value.map((tag, i) => (
            <span
              key={i}
              className="px-2 py-1 bg-gray-200 text-gray-800 text-xs rounded-full"
            >
              {tag.trim()}
            </span>
          ))}
        </div>
      ) : (
        value || "-"
      )}
    </span>
  </div>
);

// Skeleton Loader
const DetailSkeleton = () => (
  <div className="grid grid-cols-2 animate-pulse">
    <div className="h-5 bg-gray-300 rounded w-3/4 mb-2" />
    <div className="h-5 bg-gray-200 rounded w-2/3 mb-2" />
  </div>
);

const attachment = [
  {
    name: "Rahul CV.pdf",
    size: "313 KB",
    date: "31 Aug, 2022",
  },
];

const BasicCard = ({ loading, data }) => {
  const navigate = useNavigate();

  const basicDetails = [
    { label: "Email", value: data?.email },
    { label: "Applied For", value: data?.jobOpening?.title },
    { label: "Current Role", value: data?.current_role },
    { label: "Current Company", value: data?.current_company },
    { label: "Address", value: data?.address },
    { label: "Hear From", value: data?.hear_from },
  ];

  const professionalDetails = [
    { label: "Experience", value: data?.experience + " years" },
    { label: "Education", value: data?.education },
    { label: "Notice Period", value: data?.notice_period },
    { label: "Current CTC", value: data?.current_ctc },
    { label: "Expected CTC", value: data?.expected_ctc },
    { label: "Key Skills", value: data?.key_skills || [] },
    { label: "Communication Skills", value: data?.communication_skills },
    {
      label: "Availability To Join",
      value: data?.availability_to_join + " days",
    },
  ];

  if (loading) {
    return (
      <div className="flex flex-col gap-2 rounded-md h-full">
        {Array.from({ length: 6 }).map((_, idx) => (
          <DetailSkeleton key={idx} />
        ))}
      </div>
    );
  }

  // if (!candidateData) {
  //   return (
  //     <p className="text-gray-500 p-4 bg-white rounded-md">
  //       <NoData
  //         title="No Data Found"
  //         message="Please try again later or contact support."
  //         buttonText={null}
  //       />
  //     </p>
  //   );
  // }

  return (
    <div className="flex flex-col gap-2 rounded-md h-full">
      <div>
        {/* Card Header */}
        <div className="border-b flex justify-between items-center p-4 text-lg font-semibold text-blue-900 bg-white">
          <h2 className="text-lg font-semibold text-blue-900">Basic Details</h2>
        </div>
        <div className="bg-white p-4 flex flex-col gap-2">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            {basicDetails.map((item, idx) => (
              <DetailCard key={idx} label={item.label} value={item.value} />
            ))}
          </div>
        </div>
      </div>
      <div>
        {/* Card Header */}
        <div className="border-b flex justify-between items-center p-4 text-lg font-semibold text-blue-900 bg-white">
          <h2 className="text-lg font-semibold text-blue-900">
            Professional Details
          </h2>
        </div>
        <div className="bg-white p-4 flex flex-col gap-2">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            {professionalDetails.map((item, idx) => (
              <DetailCard key={idx} label={item.label} value={item.value} />
            ))}
          </div>
        </div>
      </div>
      {/* <div>
 
        <div className="border-b flex justify-between items-center p-4 text-lg font-semibold text-blue-900 bg-white">
          <h2 className="text-lg font-semibold text-blue-900">
            Attachment Details
          </h2>
        </div>
        <div className="bg-white p-4 flex flex-col gap-2"></div>
      </div> */}
    </div>
  );
};

export default BasicCard;
